import { Field } from 'formik';
import React from 'react';
import styled from 'styled-components';

import { TextField, SubmitButton } from '../../forms';

const FormGeneral = () => (
  <Wrapper>
    <Field
      type="email"
      name="email"
      label="Work Email"
      component={TextField}
      placeholder="info@company.com"
      required
    />
    <SubmitButton>Subscribe</SubmitButton>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;

  > div,
  button {
    width: 100%;
  }
  ${({ theme }) => `
      @media ${theme.mediumUp} {
        button {
          width: auto;
        }
        div {
          margin-bottom: 0;
          padding-right: 20px;
          flex: auto;
          width: auto;
        }
      }
  `}
`;

export default FormGeneral;
